export default "__VITE_ASSET__ad1242fe__"